import React, { useState, useCallback, useMemo, useRef } from "react";
import "./style.less";
import { Grid, Modal } from "semantic-ui-react";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import ModifiedCalendar from "../../../common/components/ModifiedCalendar";
import { setTasksDueDateFilter } from "../../../redux/rm-buddies/actions";

const getCurrentAndNextWeekOf = date => {
  const start = moment(date)
    .startOf("isoWeek")
    .endOf("day");
  const end = moment(date)
    .endOf("isoWeek")
    .clone()
    .add(7, "d")
    .endOf("day");

  const days = [];
  let day = start;

  while (day <= end) {
    days.push(day);
    day = day.clone().add(1, "d");
  }
  return days;
};

function TasksDueDateSelector() {
  const fromDate = useSelector(
    ({ rmBuddies }) => rmBuddies.tasksDueDateFilter.fromDate
  );

  const toDate = useSelector(
    ({ rmBuddies }) => rmBuddies.tasksDueDateFilter.toDate
  );

  const [openCalendar, setOpenCalendar] = useState(false);

  const closeModal = useCallback(() => setOpenCalendar(false), [
    setOpenCalendar
  ]);
  const openModal = useCallback(() => setOpenCalendar(true), [setOpenCalendar]);

  const dispatch = useDispatch();

  const setDueDate = useCallback(
    value => {
      dispatch(
        setTasksDueDateFilter({
          fromDate: value,
          toDate: value
        })
      );
    },
    [dispatch]
  );
  const setDueDateAndClose = useCallback(
    value => {
      dispatch(
        setTasksDueDateFilter({
          fromDate: value.endOf("day"),
          toDate: value.endOf("day")
        })
      );
      setOpenCalendar(false);
    },
    [dispatch, setOpenCalendar]
  );
  const weekCache = useRef();
  const weeksArr = useMemo(() => {
    if (
      !weekCache.current ||
      fromDate.isBefore(weekCache.current[0]) ||
      fromDate.isAfter(weekCache.current[weekCache.current.length - 1])
    ) {
      const result = getCurrentAndNextWeekOf(fromDate);
      weekCache.current = result;
    }
    return weekCache.current;
  }, [fromDate]);

  return (
    <div className="TasksDueDateSelector">
      <div className="TasksDueDateSelector-calenderMain">
        <Grid>
          <Grid.Column width={8}>
            <h4>Showing Tasks due for:</h4>
            <h3>
              {fromDate.format("DD MMM YYYY").toUpperCase()}{" "}
              {fromDate.format("DD MMM YYYY") !== toDate.format("DD MMM YYYY")
                ? ` to ${toDate.format("DD MMM YYYY").toUpperCase()}`
                : ``}{" "}
            </h3>
            <div className="TasksDueDateSelector-calenderLeft">
              <ul>
                {weeksArr.slice(0, 7).map(e => (
                  <li key={e.format("DD MMM YYYY")}>
                    <p className="calenderLeft-weeks">{e.format("dd")[0]} </p>
                    <p
                      onClick={() => setDueDate(e)}
                      className={`${
                        e.format("DD") === fromDate.format("DD") ? "active" : ""
                      } calenderLeft-dates`}
                    >
                      {e.format("DD")}
                    </p>
                  </li>
                ))}
              </ul>
            </div>
          </Grid.Column>
          <Grid.Column width={8}>
            <h3>&nbsp;</h3>
            <h4>
              UPCOMING WEEK{" "}
              <img
                style={{
                  position: "absolute",
                  right: "20px",
                  height: "20px",
                  cursor: "pointer"
                }}
                onClick={openModal}
                alt="Due Date Chooser"
                src={`${process.env.PUBLIC_URL}/cal.png`}
              />
            </h4>
            <div className="TasksDueDateSelector-calenderRight">
              <ul>
                {weeksArr.slice(7).map(e => (
                  <li key={e.format("DD MMM YYYY")}>
                    <p className="calenderLeft-weeks">{e.format("dd")[0]} </p>
                    <p
                      onClick={() => setDueDate(e)}
                      className={`${
                        e.format("DD") === fromDate.format("DD") ? "active" : ""
                      } calenderLeft-dates`}
                    >
                      {e.format("DD")}
                    </p>
                  </li>
                ))}
              </ul>
            </div>
          </Grid.Column>
        </Grid>
      </div>
      <Modal
        size="mini"
        open={openCalendar}
        closeOnEscape={true}
        closeOnDimmerClick={true}
        onClose={closeModal}
      >
        <Modal.Content>
          <ModifiedCalendar
            selectRange={false}
            date={fromDate}
            onChange={setDueDateAndClose}
          />
        </Modal.Content>
      </Modal>
    </div>
  );
}

TasksDueDateSelector.defaultProps = {};

TasksDueDateSelector.propTypes = {};

export default TasksDueDateSelector;
